import { CircularProgress } from '@mui/material';
import React from 'react';

const ButtonWithLoading = ({
  isLoading = false,
  label,
  onClick,
  ...restProps
}: any) => {
  return (
    <button onClick={onClick} {...restProps}>
      {isLoading ? <CircularProgress size={16} color="inherit" /> : label}
    </button>
  );
};

export default ButtonWithLoading;
